import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_044.jpg';
page.word = [
  {
    id: 'page022_game2',
    icon: 'ikona_cw2',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    wordObj: {
      text: 'Napisz imiona dzieci w pustych ramkach. Kliknij <br/>w ikonę programu Word.',
      audio: 'files/page022/z22c2.mp3',
      item: {
        path: 'informatyka/files/page022/22_ćw_2_word.docx',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 200,
    },
  },
];
page.games = [
  {
    id: 'page997_game2',
    tooltip: '',
    icon: 'ikona_cw1',
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  // {
  //   id: 'page010_game1',
  //   tooltip: '',
  //   icon: 'ikona_cw1',
  //   pos: {
  //     x: RIGHT,
  //     y: 0,
  //   },
  // },
  // {
  //   id: 'page010_game2',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: RIGHT,
  //     y: 200,
  //   },
  // },
  {
    id: 'page022_game3',
    tooltip: '',
    icon: 'ikona_cw3',
    pos: {
      x: LEFT,
      y: 400,
    },
  },
  // {
  //   id: 'page019_game4',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: RIGHT,
  //     y: 600,
  //   },
  // },
  // {
  //   id: 'page010_game5',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: RIGHT,
  //     y: 800,
  //   },
  // },
];
page.images = [
  {
    imageId: 'page044_zoom0',
    rectangle: {
      x: 1256,
      y: 1370,
      width: 526,
      height: 774,
    },
    imageSrc: 'images/page044/044 6.jpg',
  },
  {
    imageId: 'page044_zoom1',
    rectangle: {
      x: 696,
      y: 1368,
      width: 532,
      height: 770,
    },
    imageSrc: 'images/page044/044 5.jpg',
  },
  {
    imageId: 'page044_zoom2',
    rectangle: {
      x: 140,
      y: 1368,
      width: 524,
      height: 770,
    },
    imageSrc: 'images/page044/044 4.jpg',
  },
  {
    imageId: 'page044_zoom3',
    rectangle: {
      x: 1256,
      y: 418,
      width: 526,
      height: 768,
    },
    imageSrc: 'images/page044/044 3.jpg',
  },
  {
    imageId: 'page044_zoom4',
    rectangle: {
      x: 698,
      y: 416,
      width: 526,
      height: 772,
    },
    imageSrc: 'images/page044/044 2.jpg',
  },
  {
    imageId: 'page044_zoom5',
    rectangle: {
      x: 140,
      y: 418,
      width: 528,
      height: 770,
    },
    imageSrc: 'images/page044/044 1.jpg',
  },
];
export default page;
